import { namespace } from './namespace.js';
import * as Core from '../index.js';
var PollEv = {
  namespace: namespace,
  env: Core.env,
  Util: Core.Util,
  Model: Core.Model,
  Ajax: Core.Ajax,
  Core: {
    version: Core.version
  }
};
export default PollEv;